import { createPinia } from "pinia";

export function createStores() {
  const pinia = createPinia();
  return pinia;
}

export * from "./useContextStore";
export * from "./useAuthStore";
export * from "./useLoadingStore";
export * from "./useSettingsStore";
